export const translationAR = {
  top: {
    text_1: 'طعام طازج وكوكب أفضل',
    text_2: 'توصي منظمة العفو الدولية',
    text_3: 'الآلاف من الوصفات',
    text_4: 'مكان يساعدك في إدارة المكونات',
    text_5: 'وصفات من مطابخ متنوعة، قوائم أسبوعية، قائمة تسوق',
    text_6: '',
  },
  main_function: {
    text_1: 'الوظائف الرئيسية',
    text_1_1: 'حافظ على طعامك طازجًا!',
    text_1_2: 'تلقي تنبيهات من أداة التحقق من الطزاجة للمساعدة في تجنب إهدار الطعام',
    text_2_1: 'اقتراحات وصفات بالذكاء الاصطناعي',
    text_2_2: 'اكتشف وصفات من مطابخ العالم بناءً على المكونات المتبقية في ثلاجتك',
    text_3_1: 'قوائم للأسبوع بأكمله',
    text_3_2: 'قم بإنشاء قوائم للأسبوع بأكمله',
    text_4_1: 'قائمة التسوق',
    text_4_2: 'أنشئ وحدث قوائم التسوق للاستعداد لرحلات التسوق',
    text_5: 'تحميل',
    text_6: 'iFridge سيساعدك على',
    text_7_1: 'أن تصبح ربة منزل أفضل',
    text_7_2: 'تقليل الهدر وجعل الكوكب أكثر صحة',
    text_7_3: 'الاستمتاع بالطهي',
  },
  rate_box: {
    text_1: 'مراجعات المستخدمين',
  },
  faqs: {
    text_1: 'الأسئلة الشائعة',
    text_2_1: 'ما هي أنواع الحسابات؟ هل يمكنني استخدام التطبيق مجانًا؟',
    text_2_2: `لديك الشهر الأول لاستخدام جميع وظائف التطبيق مجانًا وبدون إعلانات.
      <br /><br />بعد الشهر الأول، سيتم تحويل حسابك تلقائيًا إلى حساب مجاني.
      <br /><br />مع الحساب المجاني، يمكنك استخدام الوظائف الأساسية للتطبيق مثل: مكونات المواد الغذائية، تقرير حالة المكونات اليومية. لا يمكنك استخدام بعض الوظائف المتقدمة مثل: اقتراحات وصفات الذكاء الاصطناعي، قوائم أسبوعية، قائمة التسوق. ستظهر الإعلانات أيضًا عند استخدام التطبيق.
      <br /><br />للاستفادة من جميع وظائف التطبيق بدون إعلانات، تحتاج إلى الترقية إلى حساب بريميوم بتكلفة شهرية معقولة جدًا.`,
    text_3_1: 'ما تكلفة حساب بريميوم؟',
    text_3_2: `يمكنك الاشتراك شهريًا أو سنويًا.
      <br /><br />التكلفة الشهرية: 0.99 دولار شهريًا.
      <br /><br />التكلفة السنوية: 9.99 دولار سنويًا.
      <br /><br />لا توجد أي رسوم إضافية.`,
    text_4_1: 'هل يمكنني الاشتراك بحساب بريميوم بدون دفع؟',
    text_4_2: `بالتأكيد يمكنك ذلك.
      <br /><br />للاشتراك بحساب بريميوم، يمكنك استخدام نقاط iFridge.
      <br /><br />يمكنك شراء نقاط iFridge من خلال متجر التطبيقات/Google Play: على شاشة الإعدادات، انقر على قائمة النقاط التي ستأخذك إلى شاشة شراء النقاط.
      <br /><br />أو يمكنك كسب نقاط iFridge من خلال مشاهدة الإعلانات: على شاشة الإعدادات، انقر على قائمة الإعدادات الأخرى، انقر على مشاهدة الإعلانات.`,
    text_5_1: 'هل أحصل على نقاط iFridge عند مشاهدة الإعلانات؟',
    text_5_2: `يمكنك كسب نقاط iFridge من خلال مشاهدة الإعلانات.
      <br /><br />حسب بلدك، ستتلقى عددًا معينًا من نقاط iFridge مقابل كل مشاهدة إعلان (وفقًا لأنظمة Google Admob). بعد مشاهدة إعلان، تحتاج إلى الانتظار لمدة 20 دقيقة لمشاهدة الإعلان التالي.`,
    text_6_1: 'هل يمكنني كسب نقاط iFridge من خلال إحالة الأصدقاء؟',
    text_6_2: `يمكنك بالتأكيد الحصول على نقاط iFridge من خلال إحالة الأصدقاء.
      <br /><br />حسب بلدك، يمكنك الحصول على كمية معينة من نقاط iFridge عند إحالة الأصدقاء عن طريق مشاركة معلومات حول iFridge على الشبكات الاجتماعية مثل Facebook، Twitter، إلخ.
      <br /><br />خلال شهر واحد، يمكنك فقط الحصول على نقاط iFridge مرة واحدة للإحالات.`,
    text_7_1: 'هل يتم تخزين بياناتي الشخصية بأمان؟ هل يتم مشاركتها مع أطراف ثالثة؟',
    text_7_2:
      'يتم تخزين بياناتك بالكامل على هاتفك وهي آمنة تمامًا. نحن لا نخزن بياناتك الشخصية على خوادمنا، ولا نشارك بياناتك الشخصية مع أي أطراف ثالثة.',
    text_8_1: 'إذا كنت بحاجة إلى دعم، كيف أتواصل؟',
    text_8_2: `يمكنك التواصل معنا عبر وظيفة اتصل بنا: على شاشة الإعدادات، اختر الإعدادات الأخرى، اختر اتصل بنا.
      <br /><br />أو أرسل طلبات الدعم/الملاحظات مباشرةً إلى البريد الإلكتروني: ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: 'قد تأتي المحبة وتذهب،',
    text_2: 'لكن الجوع يزور كل يوم',
  },
};
